import { isEmpty } from '../../utils/helpers';
import { PREVIEW_MOCK_DATA, isPreviewMode } from '../../utils/previewMode';
import { makeGenericApiAction } from './shared/helpers';

export const fetchExperiencesAction = (payload) => async (dispatch) => {
  if (isPreviewMode()) {
    dispatch({ type: 'FETCH_EXPERIENCES_SUCCESS', payload: PREVIEW_MOCK_DATA.experiences });
    return;
  }

  makeGenericApiAction({
    action: 'FETCH_EXPERIENCES',
    model: 'experiences',
    errorMessage: 'an error occurred while retrieving experiences.',
    dispatch,
    method: 'get',
    path: 'experiences/getExperiences',
    payload,
    // extractModel: true,
  });
};

/**
 * Fetches all of the normal addons for the criteria.
 * Needs to be merged with the addons that came from experiences
 * @param payload
 * @returns {(function(*): Promise<void>)|*}
 */
export const fetchAddonsAction = (payload) => async (dispatch) => {
  if (isPreviewMode()) {
    dispatch({ type: 'FETCH_ADDONS_SUCCESS', payload: PREVIEW_MOCK_DATA.addons });
    return;
  }

  makeGenericApiAction({
    action: 'FETCH_ADDONS',
    model: 'addOnGroups',
    errorMessage: 'an error occurred while retrieving add-ons.',
    dispatch,
    method: 'get',
    path: 'experiences/addOnsByGroup',
    payload,
    extractModel: true,
  });
};

/**
 * Hold the experiences and addons for a booking
 */
export const holdExperiencesAction =
  (bookingId, experiences, addons = [], selectedRooms = [], fromEventWidget) =>
  async (dispatch) => {
    if (isPreviewMode()) {
      dispatch({ type: 'HOLD_EXPERIENCES_SUCCESS', payload: { data: {} } });
      return;
    }

    const payload = {
      experiences: experiences.map((experience) => ({
        experienceId: experience?.id,
        quantity: experience?.count,

        // Should not need to send any of these
        primaryOptionId: experience?.experience?.primaryOptionId,
        // experiencePrice: experience?.price,
        // totalPrice: experience?.price,
        ...(fromEventWidget && { fromEventWidget: 1 }),
      })),
      // addOns,
      // addons: [
      //   // {
      //   //   addonId: 1,
      //   //   quantity: 1,
      //   // },
      // ],
    };

    if (!isEmpty(selectedRooms)) {
      payload.selectedRooms = selectedRooms.map((room) => ({
        roomId: room?.id,
        quantity: 1,
      }));
    }

    makeGenericApiAction({
      action: 'HOLD_EXPERIENCES',
      model: 'holdSelectedAddOns',
      dispatch,
      method: 'post',
      path: `bookings/${bookingId}/holdSelectedAddOns`,
      payload,
      extractModel: true,
    });
  };

/**
 * Hold the experiences and addons for a booking
 */
export const holdSelectedRoomsAction = (bookingId, addons, selectedRooms) => async (dispatch) => {
  const payload = {
    addOns: Object.entries(addons).map(([_addonId, addon]) => ({
      addonId: addon?.addon?.id,
      quantity: addon?.count,
    })),
    selectedRooms: selectedRooms.map((room) => ({
      roomId: room?.id,
      quantity: 1,
    })),
  };

  makeGenericApiAction({
    action: 'HOLD_SELECTED_ROOMS',
    model: 'holdSelectedAddOns',
    dispatch,
    method: 'post',
    path: `bookings/${bookingId}/holdSelectedAddOns`,
    payload,
    extractModel: true,
  });
};

/**
 * Hold the experiences and addons for a booking
 */
export const updateHeldExperienceAction =
  (bookingId, experiences = [], addons = [], selectedRooms = null) =>
  async (dispatch) => {
    if (isPreviewMode()) {
      dispatch({ type: 'UPDATE_HELD_EXPERIENCE_SUCCESS', payload: { data: {} } });
      return;
    }

    const payload = {
      addOns: Object.entries(addons).map(([_addonId, addon]) => ({
        addonId: addon?.addon?.id,
        quantity: addon?.count,
      })),
    };

    // If we updated rooms, update them
    if (!isEmpty(selectedRooms)) {
      payload.selectedRooms = selectedRooms;
    }

    makeGenericApiAction({
      action: 'UPDATE_HELD_EXPERIENCE',
      model: 'updateSelectedAddons',
      dispatch,
      method: 'put',
      path: `bookings/${bookingId}/updateSelectedAddons`,
      payload,
      extractModel: true,
    });
  };

/**
 * Get the accommodation for the accommodation experience
 */
export const getExperienceAccommodationAction = (experienceID, date) => async (dispatch) => {
  makeGenericApiAction({
    action: 'FETCH_EXPERIENCE_ACCOMMODATION',
    model: 'fetchExperienceAccommodation',
    errorMessage: 'an error occurred while retrieving accommodation options.',
    dispatch,
    method: 'get',
    path: `experiences/${experienceID}/getExperienceAccommodation?date=${date}`,
  });
};

/**
 * Extra step needed for accommodation
 * TODO this feels redundant, right? How is this any different to holding an experience normally?
 */
export const holdAccommodationAction =
  (bookingId, size, experiences, tableId) => async (dispatch) => {
    if (isPreviewMode()) {
      dispatch({
        type: 'HOLD_ACCOMMODATION_SUCCESS',
        payload: { data: { addOns: [], selectableRooms: [] } },
      });
      return;
    }

    const payload = {
      size,
      tableId,
      experiences: experiences.map((experience) => ({
        experienceId: experience?.id,
        primaryOptionId: experience.experience?.primaryOptionId,
        experiencePrice: experience.experience.price, // TODO backend should definitely be validating this
        quantity: experience?.count,
        totalPrice: experience.experience.price, // TODO backend should definitely be validating this
      })),
    };

    makeGenericApiAction({
      action: 'HOLD_ACCOMMODATION',
      model: 'holdAccommodation',
      dispatch,
      method: 'post',
      path: `bookings/${bookingId}/handleFirstHeldAccommodationExperience`,
      payload,
    });
  };
